import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-card',
  template: `
    <div class="card">
      <div class="card-body">
        <h5 class="card-title" *ngIf="title">{{ title }}</h5>
        <h6 class="card-subtitle mb-2 text-muted" *ngIf="subtitle">
          {{ subtitle }}
        </h6>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule]
})
export class ZikataCardComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
}
